import { render, staticRenderFns } from "./RoleBasedAccessControlPermissions.vue?vue&type=template&id=f6b4e508&scoped=true"
import script from "./RoleBasedAccessControlPermissions.vue?vue&type=script&lang=js"
export * from "./RoleBasedAccessControlPermissions.vue?vue&type=script&lang=js"
import style0 from "./RoleBasedAccessControlPermissions.vue?vue&type=style&index=0&id=f6b4e508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b4e508",
  null
  
)

export default component.exports